<template>
  <nav class="app-nav">
    <button
      v-for="item in visibleItems"
      :key="item.id"
      type="button"
      class="nav-item"
      :class="{ active: current === item.id }"
      @click="$emit('change', item.id)"
    >
      {{ item.label }}
    </button>
  </nav>
</template>

<script>
export default {
  name: 'AppNav',
  props: {
    current: { type: String, default: 'highlight' },
    /** 是否展示「固定时长切片」二级入口 */
    showSegment: { type: Boolean, default: false },
  },
  computed: {
    visibleItems() {
      const items = [
        { id: 'highlight', label: '发现主播精彩' },
      ];
      if (this.showSegment) {
        items.push({ id: 'segment', label: '固定时长切片' });
      }
      items.push(
        { id: 'beta', label: '内测说明' },
        { id: 'pricing', label: '定价' },
      );
      return items;
    },
  },
};
</script>

<style scoped>
.app-nav {
  display: flex;
  gap: 8px;
  margin: 12px 0 16px;
  flex-wrap: wrap;
}
.nav-item {
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(15, 23, 42, 0.45);
  color: #cbd5e1;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
}
.nav-item.active {
  border-color: rgba(45, 212, 191, 0.6);
  background: rgba(15, 118, 110, 0.35);
  color: #ccfbf1;
}
</style>
